import React from 'react';
import { BrandStyles, ResetStyles } from 'radiance-ui';
import { Wordmark } from 'radiance-ui/lib/icons';

import URLS from 'jsx/constants/urls';

import {
  MainContainer,
  PageContainer,
  NavbarContainer,
  Navbar,
  NavbarSection,
} from './style';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <React.Fragment>
    <BrandStyles />
    <ResetStyles />
    <NavbarContainer>
      <Navbar>
        <NavbarSection>
          <a href={URLS.landingPage} aria-label="Back to Homepage">
            <Wordmark />
          </a>
        </NavbarSection>
      </Navbar>
    </NavbarContainer>
    <MainContainer id="main-container">
      <PageContainer>{children}</PageContainer>
    </MainContainer>
  </React.Fragment>
);

export default Layout;
